import React, { useState } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { Link, useI18next } from 'gatsby-plugin-react-i18next';
import map from 'lodash/map';
import without from 'lodash/without';

import {
  header,
  link,
  nav,
  menuButton,
  logo,
} from './Header.module.css';
import Menu from '../svg/icons/menu.svg';
import Drawer from './Drawer';

const Header = () => {
  const {
    languages,
    originalPath,
    t,
    i18n,
  } = useI18next();
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className={header}>
        <Link to="/">
          <StaticImage src="../images/logo.png" alt="Shibuya" placeholder="transparent" className={logo} />
        </Link>
        <nav className={nav}>
          <Link className={link} to="/">{t('page-titles.home')}</Link>
          &middot;
          <Link className={link} to="/about">{t('page-titles.about-us')}</Link>
          &middot;
          <Link className={link} to="/menu">{t('page-titles.menu')}</Link>
          &middot;
          <Link className={link} to="/reserve">{t('page-titles.reserve')}</Link>
          &middot;
          <Link className={link} to="/faq">{t('page-titles.faq')}</Link>
          &middot;
          <Link className={link} to="/contact">{t('page-titles.contact')}</Link>
          &middot;
          {
            map(
              without(languages, i18n.resolvedLanguage),
              (language) => (
                <Link
                  to={originalPath}
                  language={language}
                  className={link}
                  key={`site-lang-${language}`}
                >
                  {language}
                </Link>
              ),
            )
          }
        </nav>
        <button className={menuButton} onClick={() => setOpen(true)} type="button">
          <Menu />
        </button>
      </header>
      <Drawer open={open} closeDrawer={() => setOpen(false)} />
    </>
  );
};

export default Header;
